const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";

export const DEMO_ROLE_IDS = new Set([3, 4]);

export const DEFAULT_SETTINGS = {
  nom_asso: "",
  shortname_asso: "",
  responsable_asso: "",
  logo_asso: "",
  adresse_asso: "",
  commune_asso: "",
  tel_asso: "",
  mail_asso: "",
  siteweb_asso: "",
  siret_asso: "",
  facebook_asso: "",
  instagram_asso: "",
  primary_color: "#013E8E",
  about_title: "",
  about_content: "",
  carrousel_id: "",
  header1_photo_url: "",
  header2_photo_url: "",
  header_title: "",
  header_subtitle: "",
};

export function extractArray(data) {
  if (Array.isArray(data)) return data;

  if (data && typeof data === "object") {
    if (Array.isArray(data.rows)) return data.rows;
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.data)) return data.data;
    if (Array.isArray(data.galleries)) return data.galleries;
  }

  return [];
}

export function extractSettings(data) {
  if (Array.isArray(data)) return data[0] || DEFAULT_SETTINGS;
  if (data && typeof data === "object") return data;
  return DEFAULT_SETTINGS;
}

export function isExternalURL(url) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

export function resolveMediaUrl(url, fallback = "/images/asso_placeholder.webp") {
  if (!url) return fallback;

  const value = String(url).trim();

  if (
    isExternalURL(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (value.startsWith("/")) {
    return `${API_BASE}${value}`;
  }

  return value;
}

export function getCurrentStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export function isDemoMode() {
  const user = getCurrentStoredUser();
  return DEMO_ROLE_IDS.has(Number(user?.role_id));
}

export function normalizeSettings(rawSettings) {
  return {
    ...DEFAULT_SETTINGS,
    ...(rawSettings || {}),
    primary_color: rawSettings?.primary_color || DEFAULT_SETTINGS.primary_color,
    carrousel_id: rawSettings?.carrousel_id || "",
  };
}

export function stripHtml(value = "") {
  return String(value).replace(/<[^>]*>/g, "").trim();
}

export function hasValue(value) {
  return String(value || "").trim().length > 0;
}

export function getSettingsStats(settings) {
  const identityFields = [
    settings.nom_asso,
    settings.shortname_asso,
    settings.responsable_asso,
    settings.logo_asso,
    settings.siret_asso,
  ];

  const contactFields = [
    settings.adresse_asso,
    settings.commune_asso,
    settings.tel_asso,
    settings.mail_asso,
    settings.siteweb_asso,
  ];

  const homeFields = [
    settings.header1_photo_url,
    settings.header2_photo_url,
    stripHtml(settings.header_title),
    settings.header_subtitle,
    settings.about_title,
    stripHtml(settings.about_content),
  ];

  const socialFields = [settings.facebook_asso, settings.instagram_asso];

  const countFilled = (fields) => fields.filter(hasValue).length;

  const totalFields =
    identityFields.length + contactFields.length + homeFields.length + socialFields.length;

  const filledFields =
    countFilled(identityFields) +
    countFilled(contactFields) +
    countFilled(homeFields) +
    countFilled(socialFields);

  return {
    completion: Math.round((filledFields / totalFields) * 100),
    identity: countFilled(identityFields),
    identityTotal: identityFields.length,
    contact: countFilled(contactFields),
    contactTotal: contactFields.length,
    home: countFilled(homeFields),
    homeTotal: homeFields.length,
    social: countFilled(socialFields),
    socialTotal: socialFields.length,
  };
}

export function getGalleryLabel(galleries, id) {
  const gallery = galleries.find(
    (item) => String(item.id) === String(id)
  );

  return gallery?.titre || "Aucune galerie sélectionnée";
}